/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "components/Table/Table.jsx";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Button from "components/CustomButtons/Button.jsx";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import Visibility from "@material-ui/icons/Visibility";
import Add from "@material-ui/icons/Add";
import Refresh from "@material-ui/icons/Refresh";
import Replay from "@material-ui/icons/Replay";

import {
  getDeviceConfig,
  getDeviceCommands,
  createDeviceCommand
} from "../../services/commandsDataProvider";

import "react-circular-progressbar/dist/styles.css";

const MonaCommands = {
  debug_on: "",
  debug_off: "",
  clear_sys_logs: "",
  "set-system": "cfg",
  "set-user": "cfg",
  "set-cfg": "cfg",
  "get-cfg": "cfg",
  "reset-cfg": "cfg",
  "mdbs-cmd": "cfg",
  "set-cval": "cfg",
  "get-sensors": "cfg",
  "get-mdbs": "cfg",
  "update-trigger-device": "",
  "update-trigger-group": "",
  fwd: ""
};

const AVAILABLE_COMMANDS = Object.keys(MonaCommands).map(cmd => ({
  text: cmd,
  value: cmd
}));

const CALIBRATE_SENSOR_COMMAND = "Calibrate Sensor";

AVAILABLE_COMMANDS.push({
  text: CALIBRATE_SENSOR_COMMAND,
  value: CALIBRATE_SENSOR_COMMAND
});

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardIconTitle: {
    color: "#3C4858",
    margin: "10px 0 0",
    fontWeight: "300"
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  statusSuccess: {
    backgroundColor: "#e8f5e8 !important"
  },
  statusError: {
    backgroundColor: "#ffeaea !important"
  },
  statusPending: {
    backgroundColor: "#fff3cd !important"
  },
  statusRunning: {
    backgroundColor: "#e3f2fd !important"
  }
};

class DeviceCommands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceId: null,
      configData: {},
      configModalOpen: false,
      commands: [],
      loading: true,
      currentPage: 0,
      rowsPerPage: 10,
      totalCommands: 0,
      createCommandModalOpen: false,
      commandDetailsModalOpen: false,
      selectedCommand: null,
      newCommand: {
        command: "cmd-req",
        command_param: ""
      },
      resetDevice: false,
      channel: 0,
      calibrateSensorData: {
        channel: 0,
        rawValue1: "",
        actualValue1: "",
        rawValue2: "",
        actualValue2: ""
      }
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    let deviceData = this.props.deviceData;
    if (deviceData) {
      this.setState(
        {
          deviceId: deviceData.ip_address,
          deviceData: deviceData
        },
        () => {
          // Load commands after device ID is set
          this.loadCommands();
        }
      );

      getDeviceConfig(this.props.axios, deviceData.ip_address).then(data => {
        this.setState({
          configData: data
        });
      });
    } else {
      this.loadCommands();
    }
  }

  loadCommands = async () => {
    this.setState({ loading: true });
    try {
      const { deviceId } = this.state;
      if (deviceId) {
        const commandsData = await getDeviceCommands(
          this.props.axios,
          deviceId,
          this.state.currentPage,
          this.state.rowsPerPage
        );
        this.setState({
          commands: commandsData.commands || [],
          totalCommands: (commandsData && commandsData.total) || 0,
          currentPage: commandsData.currentPage || 0,
          rowsPerPage: commandsData.rowsPerPage || 10,
          loading: false
        });
      } else {
        this.setState({
          commands: [],
          totalCommands: 0,
          loading: false
        });
      }
    } catch (error) {
      this.setState({
        commands: [],
        totalCommands: 0,
        loading: false
      });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleChangeRowsPerPage = event => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      currentPage: 0
    });
  };

  getStatusRowProps = status => {
    const { classes } = this.props;
    switch (status.toLowerCase()) {
      case "completed":
        return { className: classes.statusSuccess };
      case "failed":
        return { className: classes.statusError };
      case "pending":
        return { className: classes.statusPending };
      case "running":
        return { className: classes.statusRunning };
      default:
        return {};
    }
  };

  handleCreateCommand = () => {
    this.setState({ createCommandModalOpen: true });
  };

  handleRefreshCommands = () => {
    this.loadCommands();
  };

  handleOpenCommandDetails = command => {
    this.setState({
      commandDetailsModalOpen: true,
      selectedCommand: command
    });
  };

  handleCloseCommandDetails = () => {
    this.setState({
      commandDetailsModalOpen: false,
      selectedCommand: null
    });
  };

  handleReExecuteCommand = command => {
    this.setState({
      createCommandModalOpen: true,
      newCommand: {
        command: command.command,
        command_param: command.param || ""
      },
      createCommandError: null,
      isCreatingCommand: false
    });
  };

  handleCloseCreateCommand = () => {
    this.setState({
      createCommandModalOpen: false,
      newCommand: {
        command: "",
        command_param: ""
      },
      createCommandError: null,
      isCreatingCommand: false,
      resetDevice: false,
      channel: 0,
      calibrateSensorData: {
        channel: 0,
        rawValue1: "",
        actualValue1: "",
        rawValue2: "",
        actualValue2: ""
      }
    });
  };

  handleCommandInputChange = (field, value) => {
    this.setState({
      newCommand: {
        ...this.state.newCommand,
        [field]: value
      }
    });
  };

  handleResetDeviceChange = event => {
    this.setState({ resetDevice: event.target.checked });
  };

  handleChannelChange = event => {
    const value = parseInt(event.target.value, 10);
    if (value >= 0 && value <= 5) {
      this.setState({ channel: value });
    }
  };

  handleCalibrateSensorInputChange = (field, value) => {
    this.setState({
      calibrateSensorData: {
        ...this.state.calibrateSensorData,
        [field]: value
      }
    });
  };

  getParameterHelperText = () => {
    const { newCommand, configData } = this.state;
    const selectedCommand = newCommand.command;

    if (!selectedCommand || !MonaCommands[selectedCommand]) {
      return null;
    }

    const commandType = MonaCommands[selectedCommand];
    if (commandType === "cfg" && configData && configData.data) {
      return configData.data;
    }

    return null;
  };

  handleSubmitCommand = async () => {
    const { newCommand, deviceId, resetDevice, calibrateSensorData } =
      this.state;
    if (newCommand.command.trim() && deviceId) {
      this.setState({
        isCreatingCommand: true,
        createCommandError: null
      });

      try {
        if (newCommand.command === CALIBRATE_SENSOR_COMMAND) {
          const channel = parseInt(calibrateSensorData.channel, 10);
          const rawValue1 = parseFloat(calibrateSensorData.rawValue1);
          const actualValue1 = parseFloat(calibrateSensorData.actualValue1);
          const rawValue2 = parseFloat(calibrateSensorData.rawValue2);
          const actualValue2 = parseFloat(calibrateSensorData.actualValue2);

          if (
            Number.isNaN(channel) ||
            channel < 0 ||
            channel > 5 ||
            Number.isNaN(rawValue1) ||
            Number.isNaN(actualValue1) ||
            Number.isNaN(rawValue2) ||
            Number.isNaN(actualValue2)
          ) {
            throw new Error("Please enter valid calibration inputs.");
          }

          if (rawValue1 === rawValue2) {
            throw new Error(
              "Raw value 1 and raw value 2 must be different to calculate calibration."
            );
          }

          const mcValue = Math.floor((actualValue1 - actualValue2) / (rawValue1 - rawValue2) * 10000);
          const moValue = Math.floor((actualValue1 - mcValue * rawValue1) * 10000);
          const mcKey = `mc_${channel}`;
          const moKey = `mo_${channel}`;

          await createDeviceCommand(this.props.axios, deviceId, {
            command: "set-cfg",
            command_param: ` [0] ${mcKey} ${mcValue}`
          });

          await new Promise(resolve => {
            setTimeout(resolve, 5000);
          });

          await createDeviceCommand(this.props.axios, deviceId, {
            command: "set-cfg",
            command_param: ` [1] ${moKey} ${moValue}`
          });

          this.loadCommands();
          this.handleCloseCreateCommand();
          return;
        }

        let commandParam = newCommand.command_param;

        // Add reset device prefix for set-cfg command
        if (newCommand.command === "set-cfg") {
          const resetPrefix = resetDevice ? " [1] " : " [0] ";
          commandParam = resetPrefix + commandParam;
        }

        // Add reset device and channel for set-cval command
        if (newCommand.command === "set-cval") {
          const resetPrefix = resetDevice ? "[1] " : "[0] ";
          const channelPrefix = ` [${this.state.channel}] `;
          commandParam = resetPrefix + channelPrefix + commandParam;
        }

        const payload = {
          command: newCommand.command,
          command_param: commandParam
        };

        await createDeviceCommand(this.props.axios, deviceId, payload);

        // Reload commands to show the new command
        this.loadCommands();

        this.handleCloseCreateCommand();
      } catch (error) {
        this.setState({
          createCommandError:
            error.message || "Failed to create command. Please try again.",
          isCreatingCommand: false
        });
      }
    }
  };

  renderCommandsTable() {
    const { classes, user } = this.props;
    const {
      commands,
      loading,
      currentPage,
      rowsPerPage,
      totalCommands
    } = this.state;
    let configData = this.state.configData;

    if (loading) {
      return <div>Loading commands...</div>;
    }
    const tableData =
      commands &&
      commands.map(command => [
        command.command,
        <span
          key={command.id}
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "bold",
            color: "white",
            backgroundColor:
              command.status === "C"
                ? "#4caf50"
                : command.status === "F"
                  ? "#f44336"
                  : command.status === "P"
                    ? "#2196f3"
                    : "#ff9800"
          }}
        >
          {command.status.toUpperCase()}
        </span>,
        command.command_in_time,
        command.command_read_time,
        <div
          key={`response-${command.id}`}
          style={{
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
          title={command.response}
        >
          {command.response}
        </div>,
        <IconButton
          key={`action-${command.id}`}
          size="small"
          onClick={event => {
            event.stopPropagation();
            this.handleReExecuteCommand(command);
          }}
          title="Re-execute this command"
          style={{ color: "#1976d2" }}
        >
          <Replay />
        </IconButton>
      ]);

    return (
      <Card>
        <CardHeader color="info">
          <div className={classes.headerContainer}>
            <div>
              <h4 className={classes.cardTitleWhite}>
                Device Commands & Configuration
              </h4>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                color="white"
                onClick={this.handleRefreshCommands}
                disabled={this.state.loading}
                title="Refresh commands"
              >
                <Refresh />
              </Button>
              <Button
                color="white"
                onClick={this.handleCreateCommand}
                title="Create new command"
              >
                <Add />
              </Button>
            </div>
          </div>
          <div>
            {(user.isAdmin || user.isSuperuser) &&
              this.renderDeviceConfig(configData)}
          </div>
        </CardHeader>
        <CardBody>
          <Table
            tableHeaderColor="primary"
            tableHead={[
              "Command",
              "Status",
              "Sent Time",
              "Execution Time",
              "Response",
              "Actions"
            ]}
            tableData={tableData}
            tableRowProps={commands.map(command => ({
              ...this.getStatusRowProps(command.status),
              style: { cursor: "pointer" },
              title: "Click to view command details"
            }))}
            onRowClick={(rowData, rowIndex) =>
              this.handleOpenCommandDetails(commands[rowIndex])
            }
          />
          <TablePagination
            component="div"
            count={totalCommands}
            page={currentPage}
            onChangePage={this.handleChangePage}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </CardBody>
      </Card>
    );
  }

  renderCreateCommandModal() {
    const {
      createCommandModalOpen,
      newCommand,
      isCreatingCommand,
      calibrateSensorData
    } = this.state;

    return (
      <Modal
        open={createCommandModalOpen}
        onClose={this.handleCloseCreateCommand}
        aria-labelledby="Create Device Command"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            padding: 24,
            minWidth: 400,
            maxWidth: "90vw"
          }}
        >
          <h4>Create New Command</h4>
          {this.state.createCommandError && (
            <div
              style={{
                backgroundColor: "#ffebee",
                color: "#c62828",
                padding: "12px",
                borderRadius: "4px",
                marginBottom: "16px",
                fontSize: "14px"
              }}
            >
              {this.state.createCommandError}
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: "bold"
                }}
              >
                Command
              </label>
              <CustomSelect
                labelText={newCommand.command || "Select a command"}
                items={AVAILABLE_COMMANDS}
                onChange={value =>
                  this.handleCommandInputChange("command", value)
                }
              />
            </div>
            {(newCommand.command === "set-cfg" ||
              newCommand.command === "set-cval") && (
              <div style={{ marginBottom: 16 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.resetDevice}
                      onChange={this.handleResetDeviceChange}
                      color="primary"
                    />
                  }
                  label="Reset Device"
                />
              </div>
            )}
            {newCommand.command === "set-cval" && (
              <div style={{ marginBottom: 16 }}>
                <TextField
                  label="Channel"
                  type="number"
                  variant="outlined"
                  size="small"
                  value={this.state.channel}
                  onChange={this.handleChannelChange}
                  inputProps={{
                    min: 0,
                    max: 5,
                    step: 1
                  }}
                  style={{ width: 120 }}
                  helperText="Select channel (0-5)"
                />
              </div>
            )}
            {newCommand.command === CALIBRATE_SENSOR_COMMAND && (
              <div style={{ marginBottom: 16 }}>
                <div
                  style={{
                    marginBottom: 8,
                    fontWeight: "bold"
                  }}
                >
                  Calibration Inputs
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12
                  }}
                >
                  <div>
                    <TextField
                      label="Channel"
                      type="number"
                      variant="outlined"
                      size="small"
                      value={calibrateSensorData.channel}
                      onChange={e =>
                        this.handleCalibrateSensorInputChange("channel", e.target.value)
                      }
                      inputProps={{
                        min: 0,
                        max: 5,
                        step: 1
                      }}
                      helperText="0 to 5"
                      style={{ width: "100%", maxWidth: 200 }}
                    />
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gap: 12,
                      gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))"
                    }}
                  >
                    <TextField
                      label="Raw Value 1"
                      type="number"
                      variant="outlined"
                      size="small"
                      value={calibrateSensorData.rawValue1}
                      onChange={e =>
                        this.handleCalibrateSensorInputChange(
                          "rawValue1",
                          e.target.value
                        )
                      }
                    />
                    <TextField
                      label="Actual Value 1"
                      type="number"
                      variant="outlined"
                      size="small"
                      value={calibrateSensorData.actualValue1}
                      onChange={e =>
                        this.handleCalibrateSensorInputChange(
                          "actualValue1",
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gap: 12,
                      gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))"
                    }}
                  >
                    <TextField
                      label="Raw Value 2"
                      type="number"
                      variant="outlined"
                      size="small"
                      value={calibrateSensorData.rawValue2}
                      onChange={e =>
                        this.handleCalibrateSensorInputChange(
                          "rawValue2",
                          e.target.value
                        )
                      }
                    />
                    <TextField
                      label="Actual Value 2"
                      type="number"
                      variant="outlined"
                      size="small"
                      value={calibrateSensorData.actualValue2}
                      onChange={e =>
                        this.handleCalibrateSensorInputChange(
                          "actualValue2",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            )}
            {newCommand.command !== CALIBRATE_SENSOR_COMMAND && (
              <TextField
                label="Parameter"
                fullWidth
                variant="outlined"
                value={newCommand.command_param}
                onChange={e =>
                  this.handleCommandInputChange("command_param", e.target.value)
                }
                placeholder="Enter command parameter (optional)"
              />
            )}
            {this.getParameterHelperText() && (
              <div
                style={{
                  marginTop: "12px",
                  padding: "12px",
                  backgroundColor: "#f0f8ff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  fontSize: "12px"
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                    color: "#1976d2"
                  }}
                >
                  Available Configuration Parameters:
                </div>
                <div
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    fontFamily: "monospace"
                  }}
                >
                  {Object.entries(this.getParameterHelperText()).map(
                    ([key, value]) => (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          marginBottom: "4px",
                          padding: "2px 0"
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#d32f2f",
                            minWidth: "100px",
                            marginRight: "8px"
                          }}
                        >
                          {key}:
                        </span>
                        <span style={{ color: "#388e3c" }}>
                          {typeof value === "object"
                            ? JSON.stringify(value)
                            : String(value)}
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              textAlign: "right",
              gap: "10px",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            <Button color="default" onClick={this.handleCloseCreateCommand}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={this.handleSubmitCommand}
              disabled={!newCommand.command.trim() || isCreatingCommand}
            >
              {isCreatingCommand ? "Sending..." : "Send Command"}
            </Button>
          </div>
        </Box>
      </Modal>
    );
  }

  renderCommandDetailsModal() {
    const { commandDetailsModalOpen, selectedCommand } = this.state;
    if (!selectedCommand) {
      return null;
    }

    const details = [
      { label: "ID", value: selectedCommand.id },
      { label: "Command", value: selectedCommand.command },
      { label: "Parameter", value: selectedCommand.param },
      { label: "Status", value: selectedCommand.status },
      { label: "Sent Time", value: selectedCommand.command_in_time },
      { label: "Execution Time", value: selectedCommand.command_read_time },
      { label: "Response Time", value: selectedCommand.response_time }
    ];

    return (
      <Modal
        open={commandDetailsModalOpen}
        onClose={this.handleCloseCommandDetails}
        aria-labelledby="Historical Command Details"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            padding: 24,
            minWidth: 450,
            maxWidth: "90vw",
            maxHeight: "80vh",
            overflow: "auto"
          }}
        >
          <h4>Historical Command Details</h4>
          <div style={{ marginBottom: 16 }}>
            {details.map(item => (
              <div
                key={item.label}
                style={{
                  display: "grid",
                  gridTemplateColumns: "140px 1fr",
                  gap: 8,
                  marginBottom: 8,
                  alignItems: "start"
                }}
              >
                <strong>{item.label}:</strong>
                <span>{item.value || "-"}</span>
              </div>
            ))}
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: "bold", marginBottom: 8 }}>Response</div>
            <pre
              style={{
                background: "#f5f5f5",
                borderRadius: 4,
                padding: 12,
                fontSize: 13,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                margin: 0
              }}
            >
              {selectedCommand.response || "-"}
            </pre>
          </div>
          <div style={{ textAlign: "right" }}>
            <Button color="info" onClick={this.handleCloseCommandDetails}>
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    );
  }

  renderDeviceConfig(configData) {
    if (!configData) return null;
    const { configModalOpen } = this.state;
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <div>
            <strong>Config version:</strong> {configData.version || "-"}
          </div>
          <div>
            <strong>Description:</strong> {configData.description || "-"}
          </div>
          <div>
            <strong>Active:</strong> {configData.active ? "Yes" : "No"}
          </div>
          <div>
            <strong>Created At:</strong> {configData.created_at || "-"}
          </div>
          <IconButton
            size="small"
            onClick={() => this.setState({ configModalOpen: true })}
            title="View Details"
          >
            <Visibility />
          </IconButton>
        </div>
        <Modal
          open={configModalOpen}
          onClose={() => this.setState({ configModalOpen: false })}
          aria-labelledby="Device Config Details"
        >
          <Box
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#fff",
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
              padding: 24,
              minWidth: 400,
              maxWidth: "90vw",
              maxHeight: "80vh",
              overflow: "auto"
            }}
          >
            <h4>Device Config Details</h4>
            <pre
              style={{
                background: "#f5f5f5",
                borderRadius: 4,
                padding: 12,
                fontSize: 14,
                overflowX: "auto"
              }}
            >
              {JSON.stringify(configData.data, null, 2)}
            </pre>
            <div style={{ textAlign: "right" }}>
              <Button
                color="info"
                onClick={() => this.setState({ configModalOpen: false })}
              >
                Close
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    return (
      <div>
        {this.renderCommandsTable()}
        {this.renderCreateCommandModal()}
        {this.renderCommandDetailsModal()}
      </div>
    );
  }
}

DeviceCommands.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DeviceCommands);
